import { _ } from '../../vendor'
import Inboomai18n from '../utils/Inboomai18n'

const data = { t : (a,b,c) => Inboomai18n.translate(a,b,c) }

export const app404Tpl = _.template(`
<div 
 id="inb-app-404"
 class="inb-announcement">
  <div style="margin: 0 auto;margin-top:50px">
    <div class="inb-image-box">
      <img src="assets/img/no_data.svg" />
    </div>
    <h3><%= t('app_msg_page_not_found') %></h3>
    <p><%= t('app_msg_page_not_found_body') %></p>
  </div>
</div>`)(data)

export const appCollectionEmptyTpl = _.template(`
<div
 id="inb-app-collection-empty"
 class="inb-announcement">
    <div class="inb-image-box">
      <img src="assets/img/no_data.svg" />
    </div>
    <h3><%= t('app_msg_collection_empty') %></h3>
    <p><%= t('app_msg_collection_empty_body') %></p>
</div>`)(data)

export const appPlantoolCollectionEmptyTpl = _.template(`
<div
 id="inb-app-collection-empty"
 class="inb-announcement">
    <div class="inb-image-box">
      <img src="assets/img/lost.svg" />
    </div>
    <h3><%= t('no_plan_active') %></h3>
    <br />
    <a
     href="plantool/form"
     class="button hide">
        <i class="fi fi-clipboard-pencil"></i>
        <%= t('contingent_plans') %>
    </a>
</div>`)(data)

export const appAccessErrorTpl = _.template(`
<div
 id="inb-app-access-error"
 class="inb-announcement">
    <div class="inb-image-box">
      <img src="assets/img/app_error.svg" />
    </div>
    <h3><%= t('app_msg_access_error') %></h3>
    <p><%= t('app_msg_access_error_body') %></p>
</div>`)(data)

export const appErrorTpl = _.template(`
<div
 id="inb-app-error"
 class="inb-announcement">
    <div class="inb-image-box">
      <img src="assets/img/app_error.svg" />
    </div>
    <h3><%= t('app_msg_error') %></h3>
    <p><%= t('app_msg_error_body') %></p>
</div>`)(data)

export const appRollingLoaderAnim = '<img class="rollingLoader" src="assets/img/rolling_loader.svg" />'